import { html, attr, type Signal, When } from '@tempots/dom'
import { Button } from '@tempots/beatui'
import type { CostBreakdown } from '@/services/types'

export interface CostEstimateOptions {
  costEstimate: Signal<CostBreakdown | null>
  calculating: Signal<boolean>
  onCalculateCost: () => void
}

export function CostEstimate({
  costEstimate,
  calculating,
  onCalculateCost,
}: CostEstimateOptions) {
  return html.div(
    attr.class('bg-gray-50 rounded-lg p-4 mb-4'),
    html.div(
      attr.class('flex items-center justify-between mb-2'),
      html.span(attr.class('text-sm text-gray-600'), 'Estimated Cost'),
      When(
        calculating,
        () => html.span(attr.class('text-sm text-gray-500'), 'Calculating...'),
        () =>
          html.span(
            attr.class('text-lg font-semibold text-gray-900'),
            costEstimate.map((c) =>
              c ? `${c.totalCredits} credits` : '-- credits'
            )
          )
      )
    ),
    Button(
      {
        variant: 'outline',
        size: 'sm',
        fullWidth: true,
        disabled: calculating,
        onClick: onCalculateCost,
      },
      calculating.map((c) => (c ? 'Calculating...' : 'Calculate Cost'))
    )
  )
}
